import { render, staticRenderFns } from "./Topmenu.vue?vue&type=template&id=5ae671f6&scoped=true&"
import script from "./Topmenu.vue?vue&type=script&lang=js&"
export * from "./Topmenu.vue?vue&type=script&lang=js&"
import style0 from "./Topmenu.vue?vue&type=style&index=0&id=5ae671f6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ae671f6",
  null
  
)

export default component.exports